//
//
//
//
import customPieChart from '@/components/bigDataChart/customPieChart'; // import { querySiteCategoryTotal } from '@/api/api'
// import { listenMapChange } from '@/mixins/listenMapChange'

export default {
  name: 'siteOnline',
  //   mixins: [listenMapChange],
  created: function created() {
    this.querySiteCategoryTotalChart();
  },
  props: {
    width: {
      type: String,
      default: '450px'
    },
    height: {
      type: String,
      default: '280px'
    }
  },
  components: {
    customPieChart: customPieChart
  },
  methods: {
    // 站点类型统计
    querySiteCategoryTotalChart: function querySiteCategoryTotalChart(areaId) {
      var that = this;
      var params = {
        areaId: areaId
      }; //   querySiteCategoryTotal(params).then((res) => {
      // if (res.success) {
      //   var data = {
      //     legendData: [],
      //     seriesData: [],
      //   }
      //   res.result.forEach((item, i) => {
      //     data.legendData.push(item.dictText)
      //     data.seriesData.push({
      //       name: item.dictText,
      //       value: item.value,
      //     })
      //   })

      setTimeout(function () {
        that.$refs.chart6.initCustomPieChart();
      }, 1000); // }
      //   })
    }
  } //   watch: {
  //     currentAreaId(value) {
  //       if (value == '') {
  //         this.querySiteCategoryTotalChart()
  //       } else {
  //         this.querySiteCategoryTotalChart(value)
  //       }
  //     },
  //   },

};